import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../layout/header/Header";
import Footer from "../../layout/footer/Footer";
import Breadcrumb from "../../components/Breadcrumb";

function Register() {
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [cpassword, setCpassword] = useState();

  return (
    <>
      <Header />
      <Breadcrumb title={"Register"} />

      <div className="max-w-md my-10 border border-gray-50 mx-auto p-5 rounded shadow-sm drop-shadow-sm">
        <p className="text-2xl text-center font-semibold">Create Account</p>

        <form>
          <div className="relative w-full mb-4 mt-6 space-y-3">
          <input
              type="text"
              className="px-3 py-3 border border-gray-200 rounded text-sm w-full focus:outline-none"
              placeholder="Name"
              onChange={(e) => setName(e.target.value)}
              autoFocus
            />
            <input
              type="email"
              className="px-3 py-3 border border-gray-200 rounded text-sm w-full focus:outline-none"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="text"
              className="px-3 py-3 border border-gray-200 rounded text-sm w-full focus:outline-none"
              placeholder="Password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <input
              type="text"
              className="px-3 py-3 border border-gray-200 rounded text-sm w-full focus:outline-none"
              placeholder="Confirm Password"
              onChange={(e) => setCpassword(e.target.value)}
            />
          </div>
          <div className="flex items-center justify-between text-gray-600 text-sm mb-4">
            <div className="flex items-center space-x-1">
              <input
                type="checkbox"
                className="border border-gray-300 accent-current text-green-600 focus:ring-green-600"
                id="accept"
              />
              <label htmlFor="accept">Accept all terms & conditions</label>
            </div>
          </div>
          <button
            type="submit"
            className="bg-primary rounded-full text-white w-full py-2.5"
          >
            Register
          </button>
        </form>
        <p className="text-gray-600 text-center mt-5">
          Already have an account?&nbsp;
          <span className="text-black font-medium">
            <Link to={"/login"}>Login</Link>
          </span>
        </p>
      </div>
      <Footer />
    </>
  );
}

export default Register;
